import { formatISODate } from '@/src/shared/utils/datetime';
import { EncryptionManager } from '@/src/shared/utils/encryption_manager';
import { safeParseZodObject } from '@/src/shared/utils/parser';
import { TForgotPass } from '../schemas/forgot-pass';
import { SLogin, TLogin } from '../schemas/login';
import { TRegistration } from '../schemas/registration';
import {
  SRegisterRequest,
  SVerifyOTPRequest,
  TRegisterRequest,
  TVerifyOTPRequest,
} from '../schemas/request';
import { TVerifyOTP } from '../schemas/verify-otp';

export async function mapLoginToLoginRequest(input: TLogin) {
  await EncryptionManager.loadPublicKeyFromPem(
    process.env.NEXT_PUBLIC_ENCRYPTION_PUBLIC_KEY!
  );

  return safeParseZodObject<TLogin>(SLogin, {
    username: await EncryptionManager.encryptString(input.username),
    password: await EncryptionManager.encryptString(input.password),
  });
}

export async function mapRegistrationToRegistrationRequest(
  input: TRegistration | TForgotPass
) {
  await EncryptionManager.loadPublicKeyFromPem(
    process.env.NEXT_PUBLIC_ENCRYPTION_PUBLIC_KEY!
  );

  if ('is_business' in input) {
    return {
      gmail: input.email,
      is_business: input.is_business,
    };
  }

  return safeParseZodObject<TRegisterRequest>(SRegisterRequest, {
    delete: [],
    upsert: [
      {
        model: 'User',
        data: [
          {
            id: null,
            full_name: input.fullName,
            fk_model: {},
            whatsapp: input.phoneNumber,
            email: input.email,
            username: await EncryptionManager.encryptString(input.username),
            tnc_version: input.tncVersion,
            privacy_version: input.privacyVersion,
          },
          {
            id: null,
            password: await EncryptionManager.encryptString(input.password),
            fk_model: {},
          },
        ],
      },
      {
        model: 'Individual',
        data: [
          {
            id: null,
            nickname: input.nickname,
            fk_model: { user: null, referred_by: null, race: null },
            gender: input.gender,
            birthdate: formatISODate(input.birthDate),
          },
        ],
      },
    ],
  });
}

export function mapVerifyOTPToVerifyOTPRequest(input: TVerifyOTP) {
  return safeParseZodObject<TVerifyOTPRequest>(SVerifyOTPRequest, {
    otp: input.otp,
  });
}
